// Generated by Melange

import * as Json__Json_decode from "melange-json/Json_decode.jsx";
import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Stdlib from "melange/stdlib.jsx";
import * as Subsonic__BaseArtist from "./baseArtist.jsx";

function basic_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.name;
  return {
    name: v !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v) : Ppx_deriving_json_runtime.of_json_error("missing field \"name\"")
  };
}

function basic_to_json(x) {
  return {
    name: x.name
  };
}

function partial_arg_0(json) {
  return {
    TAG: /* Artist */ 0,
    _0: Subsonic__BaseArtist.of_json(json)
  };
}

const partial_arg_1 = {
  hd: (function (json) {
    return {
      TAG: /* BasicInfo */ 1,
      _0: basic_of_json(json)
    };
  }),
  tl: /* [] */ 0
};

const partial_arg = {
  hd: partial_arg_0,
  tl: partial_arg_1
};

function of_json(param) {
  return Json__Json_decode.oneOf(partial_arg, param);
}

function to_json(param) {
  return Stdlib.failwith("Not supported");
}

export {
  basic_of_json,
  basic_to_json,
  of_json,
  to_json,
}
/* No side effect */
